const COMPONENT_PREFIX = 'pp_';

export { COMPONENT_PREFIX };
